import React from "react";
import ICtx from "../ICtx";


export const AppCtxContext = React.createContext<ICtx>({} as ICtx);
